import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import {
  unstable_HistoryRouter as HistoryRouter,
  useRoutes,
} from "react-router-dom";
import { ThemeProvider, CssBaseline } from "@mui/material";
import theme from "theme/theme";
import { appRoutes } from "routes";
import { UserProvider } from "contexts/UserContext";
import { history } from "services/navigateUtils";

const queryClient = new QueryClient();

function AppRoutes() {
  return useRoutes(appRoutes);
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <HistoryRouter history={history}>
          <UserProvider>
            <AppRoutes />
          </UserProvider>
        </HistoryRouter>
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;
